import { API_ROOT } from '../../config/config'
import { doDownload, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

const API_PATH = API_ROOT + '/subproject/manage'

//แบบฟอร์มเสนอโครงการย่อย
export const getPropersalTemplate = (masterProjectCode) => {
  const url = `${API_PATH}/template/${masterProjectCode}`
  return doGet(url)
}

//สร้าง โครงการย่อย
export const createSubProject = (masterProjectCode, formId) => {
  const url = `${API_PATH}/create/${masterProjectCode}/${formId}`
  return doPost(url)
}

//1.ยื่นข้อเสนอโครงการ
export const getSubmitSubProject = (projectId) => {
  const url = `${API_PATH}/submit/${projectId}`
  return doGet(url)
}

export const submitSubProject = (projectId) => {
  const url = `${API_PATH}/submit/${projectId}`
  return doPost(url)
}

export const getSubProjectSubmitPdf = (projectId) => {
  // const API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/subproject/proposal/${projectId}/form`
  return doDownload(url)
}
